import { media } from '@mnd-frontend/ui';
import styled from 'styled-components';

export const GraphContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  flex-wrap: nowrap;
  gap: 1rem;
  > *:last-child {
    width: 100%;
  }
  padding: 1rem;
  ${media.lessThan('tablet')} {
    padding: 0rem;
  }
`;
